import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'image',
    'placeholder',
    'input',
    'removeField',
    'removeButton',
    'submitButton',
  ];

  static values = {
    auto: Boolean,
    hiddenClass: String,
  };

  displayPreview(event) {
    const input = event.target;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.imageTarget.src = event.currentTarget.result;
        this.imageTarget.classList.remove(this.hiddenClassValue);
        this.placeholderTarget.classList.add(this.hiddenClassValue);

        if (this.hasRemoveButtonTarget)
          this.removeButtonTarget.classList.remove('hidden');

        if (this.hasRemoveFieldTarget) this.removeFieldTarget.value = '0';

        if (this.autoValue) this.autoSubmit();
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  removeImage() {
    this.removeFieldTarget.value = '1';
    this.imageTarget.classList.add(this.hiddenClassValue);
    this.removeButtonTarget.classList.add('hidden');
    this.placeholderTarget.classList.remove(this.hiddenClassValue);
  }

  // Start upload immediately by clicking the hidden submit button
  autoSubmit() {
    if (!this.hasSubmitButtonTarget)
      console.error('submitButtonTarget not found!');

    this.submitButtonTarget.click();
  }
}
